import PushSettingsPanel from './PushSettingsPanel.component'

export default PushSettingsPanel
